import { ILocation } from "@/api/registerTree/registerTree.model"

export const localDate = (date?: string): string => {
  const parsedDate = new Date(date ?? "")

  if (!(parsedDate instanceof Date)) {
    return ""
  }

  const formattedDate = parsedDate.toLocaleDateString(window.__STATE__?.culture ?? "en-GB", {
    hour12: false,
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  })
  return formattedDate
}

export const measureDistanceInMeters = (coord1: ILocation, coord2: ILocation): number => {
  const R = 6371e3
  const toRadians = (deg: number) => deg * (Math.PI / 180)

  const lat1Rad = toRadians(coord1.lat)
  const lat2Rad = toRadians(coord2.lat)
  const deltaLatRad = toRadians(coord2.lat - coord1.lat)
  const deltaLngRad = toRadians(coord2.lng - coord1.lng)

  const a =
    Math.sin(deltaLatRad / 2) * Math.sin(deltaLatRad / 2) +
    Math.cos(lat1Rad) * Math.cos(lat2Rad) * Math.sin(deltaLngRad / 2) * Math.sin(deltaLngRad / 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

  return R * c
}
